import WarningAmberOutlined from "@mui/icons-material/WarningAmberOutlined";
import { Box, Tooltip, Typography } from "@mui/material";

interface PdsLinkBadgeProps {
  hasUsablePdsLink: boolean;
}

/**
 * Only the absent case carries an icon. An unlinked patient is the exception
 * worth spotting while scanning a page of requests, so the icon is reserved for
 * it rather than marking both states.
 */
export function PdsLinkBadge({ hasUsablePdsLink }: PdsLinkBadgeProps) {
  if (hasUsablePdsLink) {
    return (
      <Tooltip title="Patient is linked to PDS, so their NHS number came from the national record">
        <Typography
          component="span"
          variant="body2"
          data-testid="pds-link-badge"
          sx={{ color: "text.secondary" }}
        >
          Linked
        </Typography>
      </Tooltip>
    );
  }

  return (
    <Tooltip title="Patient is not linked to PDS, so we hold no PDS-sourced NHS number or registered GP — the local authority responsible for payment cannot be derived">
      <Box
        data-testid="pds-link-badge"
        sx={{
          display: "inline-flex",
          alignItems: "center",
          gap: 0.5,
          color: "warning.dark",
          whiteSpace: "nowrap",
        }}
      >
        <WarningAmberOutlined fontSize="small" />
        <Typography component="span" variant="body2">
          No Link
        </Typography>
      </Box>
    </Tooltip>
  );
}
